import { filter, fromEvent, map, partition } from 'rxjs';
import redirectToSearchCommunityResults from './redirectHandler';

const searchSubmitElement = document.querySelector('[data-search-submit]');

/**
 * redirectToSearchCommunityResults: Redirects the user to the search results
 * page for the specified location.
 * @param {string} searchValue - The location value to be used in the search results page URL.
 * Note: 'form' is being used for the old typeadhead and 'data-right-rail-search'
 * is being used for the new typeahead.
 */
const getContainerByElement = (element) => {
  if (!element) {
    return null;
  }
  return element.closest('form') || element.closest('[data-right-rail-search]');
};

const searchInput = document.getElementById('blog_typeahead_input');
const searchForm = getContainerByElement(searchInput);

/**
 * Opens a new browser tab with the search results for the given search text.
 * @param {string} searchText - The text to search for.
 */
const openSearchUrl = (searchText) => {
  if (!searchText) {
    return;
  }

  redirectToSearchCommunityResults(searchText);
};

/**
 * Toggles the typeahead error container and the 'error' class on the closest form.
 * @param {boolean} show - If true, shows the error; otherwise hides it.
 */
const toggleErrorContainer = function (show) {
  const errorContainer = document.getElementById('blog_typeahead_error');
  const form = getContainerByElement(errorContainer);
  if (!form) { return; }
  form.classList.toggle('nhs-c-typeahead__form--error', !!show);
};

// observables for search submit and form click outside
const formOutClick$ = fromEvent(document, 'click').pipe(filter((event) => (
  !event.target.matches('[data-search-submit]') && !searchForm.contains(event.target))))
const searchSubmit$ = fromEvent(searchSubmitElement, 'click').pipe(
  filter(event => event.target?.matches('[data-search-submit]')),
  map(() => document.getElementById('blog_typeahead_input').value.trim())
);
const [submitSearchText$, displayError$] = partition(
  searchSubmit$,
  (searchValue) => searchValue
);

submitSearchText$.subscribe(openSearchUrl);
displayError$.subscribe(() => toggleErrorContainer(true));
formOutClick$.subscribe(() => toggleErrorContainer(false));